import { render, staticRenderFns } from "./ManoDeObra.vue?vue&type=template&id=53b98122"
import script from "./ManoDeObra.vue?vue&type=script&lang=js"
export * from "./ManoDeObra.vue?vue&type=script&lang=js"
import style0 from "./ManoDeObra.vue?vue&type=style&index=0&id=53b98122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports